export default __webpack_public_path__ + "static/media/plain-sticker-B.85b39b40.png";